import L from "leaflet";
import { useEffect, useState } from "react";
import { Marker, Popup, SVGOverlay, Tooltip } from "react-leaflet";
// import MiniTurbineIconSVG from "../../../images/SVG/WindTurbine.svg";

// import MiniTurbineIconSVG from "../../../images/Icons/Turbine.svg";
// import VisibilitySensor from "../../../images/Icons/VisibilitySensor.svg";

// import TowerObstructionLight from "../../../images/Icons/V2/TowerObstructionLight.svg";
import AviationLightRedCircle from "../../../images/Icons/V2/AviationObstructionLightLowIntensity.svg";
import AviationRedCircle from "../../../images/Icons/V2/AviationLight.svg";
import MiniTurbineIconSVG from "../../../images/Icons/V2/Turbine.svg";
import MiniTurbineIconSVG_Old from "../../../images/SVG/WindTurbine.svg";
// oss icon
import OssSquare from "../../../images/Icons/V2/OSS.svg";


import { Button, Grid } from '@mui/material';
import * as TurIcon from './TurbineIcons';
import { useDispatch } from 'react-redux'
import { NavLink } from "react-router-dom";
import { select } from "../../../features/WTG/TurbineSlice";


let iconSize = [32,32]

var turbineDotIcon = L.icon({
  iconUrl: MiniTurbineIconSVG,
  iconSize: iconSize,
  forceZIndex: 0
});

var AviationRedCircleIcon = L.icon({
  iconUrl: AviationRedCircle,
  iconSize: iconSize,
  zIndexOffset: 0

});
var AviationLightRedCircleIcon = L.icon({
  iconUrl: AviationLightRedCircle,
  iconSize: iconSize,
  zIndexOffset: 0

});

let OSSIcon = L.icon({
  iconUrl: OssSquare,
  iconSize: [28,28],
});

// var VisibilitySensorIcon = L.icon({
//   iconUrl: VisibilitySensor,
//   iconSize: [22, 22],
//   zIndexOffset: 10000
// });
/**
 * Mini turbine image svg.
 * @returns WTG
 */

export const DisplayWTG = (TurbineData) => {

// Tower Aviation Obstruction Light RED X

// if(TurbineData.equipment.aviationAidEquipment.towerObstructionLight) return TowerRedDotWithX;
if(TurbineData.type ==="OSS") return OSSIcon;
// AVIATION OBSTRUCTION LIGHT LOW INTENSITY Light RED
if( TurbineData.equipment.aviationAidEquipment.aviationObstructionLightLowIntensity) return AviationLightRedCircleIcon
// AVIATION OBSTRUCTION LIGHT RED
if(TurbineData.equipment.aviationAidEquipment.aviationObstructionLight) return AviationRedCircleIcon;

// NORMAL DOT
else return turbineDotIcon

// if(TurbineData.type ==="IS"){
//     return turbineDotIcon
//   }
//   if(TurbineData.equipment.visibilitySensor)
//   {
//     return VisibilitySensorIcon;
//   }
//   return turbineDotIcon

}


/**
 * @param {Object} turbine 
 * @param {Number} idx 
 * @returns turbine marker with tooltip and name
 */
export function ImageTurbine({ mapConfig, map, zoom }) {


  const [image, setImage] = useState(null);
  const [textSize, setTextSize] = useState("20px")

  const dispatch = useDispatch();

  

  useEffect(() => {
    if(zoom ===12)setTextSize(9);
    else setTextSize(11);
    
    if (map) {
      setImage(mapConfig.map((TurbineData, idx) => {
        return <div key={idx} >
          {zoom > 8 ? <>

            {zoom > 10 ? null : null}

            <>
              {}
              {zoom >11 && TextOverlay(TurbineData, zoom, textSize, map)}
            
            </>
            {TurbineData.equipment.marineAidEquipment.marineHelicopterCorridorLights? TurIcon.DisplayMarineHelicopterCorridorLights(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.marineFogHorn? TurIcon.DisplayFogHorn(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.marinerRadioActivatedSoundSignals? TurIcon.DisplayMarineRadio(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.aiS_KIT_NAS_T3? TurIcon.DisplayAIS(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.mL5NM? TurIcon.DisplayMarineLantern5NM(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.mL3NM? TurIcon.DisplayMarineLantern3NM(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.mL2NM? TurIcon.DisplayMarineLantern2NM(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.boatLandingLight? TurIcon.DisplayBoatLandingLight(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.marineHelicopterCorridorLights? TurIcon.DisplayMarineHelicopterCorridorLights(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.racons? TurIcon.DisplayRacon(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.marineVisibilitySensor? TurIcon.DisplayMarineVisibilitySensor(TurbineData): null}
            {TurbineData.equipment.marineAidEquipment.marineVisibilitySensor? TurIcon.DisplayMarineVisibilitySensor(TurbineData): null}
            
            {TurbineData.equipment.aviationAidEquipment.towerObstructionLight? TurIcon.DisplayTowerRedDotWithX(TurbineData):null}
            {TurbineData.equipment.aviationAidEquipment.heliHoistLight? TurIcon.DisplayHelihoistLight(TurbineData): null}
            {TurbineData.equipment.aviationAidEquipment.heliHoistLightWithSRO? TurIcon.DisplayHelihoistLightWithSRO(TurbineData): null}
            {TurbineData.equipment.aviationAidEquipment.aviationVisibilitySensor? TurIcon.DisplayVisibilitySensor(TurbineData): null}

            <Marker position={[Number(TurbineData.lat), Number(TurbineData.long)]}
              icon={DisplayWTG(TurbineData)}
              zIndexOffset={0} 
              eventHandlers={{
                click: () => {
                  console.log('marker clicked: ' + TurbineData.name)
                  
                },
              }}
            >
              <Tooltip>
                Name: {TurbineData.name} <br />
              </Tooltip>
              <Popup>
                <Grid container>
                  No: {idx + 1} <br />
                  Name: {TurbineData.name} <br />
                  Lat: {TurbineData.lat} <br />
                  Long: {TurbineData.long}<br />
                  Type: {TurbineData.type}<br />

                </Grid>
                <Grid container marginTop={"10px"}
                  justifyContent="center">
                  <NavLink
                    style={{ textDecoration: 'none' }}
                    to="/wtg">
                    <Button size="small"
                      onClick={() => {
                        console.log("click: " + TurbineData.name)
                        dispatch(select(TurbineData))
                      }
                      } variant="outlined" style={{backgroundColor:"#263238", color:"White"}}>see more</Button>
                  </NavLink>
                </Grid>
              </Popup>
            </Marker>

            {zoom > 11 ? <>
              {/* {TurbineData.type==="IPS" ? TurIcon.DisplayIpsIcon(TurbineData): null} */}
              {/* {TurbineData.equipment.marineHelicopterCorridorLights.amount ? MAE.DisplayMarineHelicopterCorridorLights(TurbineData, idx, funcDispatch) : null} */}
            </>
              :
              null}
          </>
            :
            <>
              <Marker position={startViewPosition(mapConfig)}
                icon={DisplayWTG(TurbineData)}
                eventHandlers={{
                  click: () => {
                    // console.log('marker clicked')
                  },
                }}
              >
                <Tooltip>
                  Windturbine park. <br></br>
                  Zoom in for better view.
                </Tooltip>
              </Marker>
            </>
          }
        </div >
      }))
    }
  }, [map, mapConfig, zoom, textSize, dispatch]);
  return image
}


// Version 1 below!!!

var MiniTurbineIcon_Old = L.icon({
  iconUrl: MiniTurbineIconSVG_Old,
  iconSize: [22, 22],
  zIndexOffset: 10000
});
/**
 * Mini turbine image svg.
 * @returns WTG
 */

export const DisplayWTG_Old = () => {
  return MiniTurbineIcon_Old
}

/**
 * @param {Object} turbine 
 * @param {Number} idx 
 * @returns turbine marker with tooltip and name
 */
 export function ImageTurbine_Old({ mapConfig, map, zoom }) {


  const [image, setImage] = useState(null);
  const [textSize, setTextSize] = useState("20px")

  const dispatch = useDispatch();


  useEffect(() => {
    if(zoom ===12)setTextSize(9);
    else setTextSize(11);
    
    if (map) {
      setImage(mapConfig.map((TurbineData, idx) => {
        return <div key={idx} >
          {zoom > 8 ? <>

            {zoom > 10 ? null : null}

            <>
              {}
              {zoom >11 && TextOverlay(TurbineData, zoom, textSize, map)}
            
            </>
            {/* {TurbineData.type ==="SPS" ? AAE.DisplayVisibilitySensor(TurbineData) : null} */}
            {TurbineData.type ==="SPS" ? TurIcon.DisplaySpsIcon(TurbineData) : null}
            {TurbineData.type==="IPS" ? TurIcon.DisplayIpsIcon(TurbineData): null}
            {TurbineData.type==="PS" ? TurIcon.DisplayPsIcon(TurbineData): null}
              

            <Marker position={[Number(TurbineData.lat), Number(TurbineData.long)]}
              icon={DisplayWTG_Old()}
              eventHandlers={{
                click: () => {
                  console.log('marker clicked: ' + TurbineData.name)
                  
                
                },
              }}
            >
              <Tooltip>
                Name: {TurbineData.name} <br />
              </Tooltip>
              <Popup>
                <Grid container>
                  No: {idx + 1} <br />
                  Name: {TurbineData.name} <br />
                  Lat: {TurbineData.lat} <br />
                  Long: {TurbineData.long}<br />
                  Type: {TurbineData.type}<br />

                </Grid>
                <Grid container marginTop={"10px"}
                  justifyContent="center">
                  <NavLink
                    style={{ textDecoration: 'none' }}
                    to="/wtg">
                    <Button size="small"
                      onClick={() => {
                        console.log("click: " + TurbineData.name)
                        dispatch(select(TurbineData))
                      }
                      } variant="outlined" style={{backgroundColor:"#263238", color:"White"}}>see more</Button>
                  </NavLink>
                </Grid>
              </Popup>
            </Marker>
            {zoom > 11 ? <>
              {/* {TurbineData.type==="IPS" ? TurIcon.DisplayIpsIcon(TurbineData): null} */}
              {/* {TurbineData.equipment.marineHelicopterCorridorLights.amount ? MAE.DisplayMarineHelicopterCorridorLights(TurbineData, idx, funcDispatch) : null} */}
            </>
              :
              null}
          </>
            :
            <>
              <Marker position={startViewPosition(mapConfig)}
                icon={DisplayWTG_Old()}
                eventHandlers={{
                  click: () => {
                    // console.log('marker clicked')
                  },
                }}
              >
                <Tooltip>
                  Windturbine park. <br></br>
                  Zoom in for better view.
                </Tooltip>
              </Marker>
            </>
          }
        </div >
      }))
    }
  }, [map, mapConfig, zoom, textSize, dispatch]);
  return image
}





/**
* First it takes the WTG name and seperates it by the Char "-" Number in a array
* Secondly it slice the first Char
* Firthly it add first char and number into a short name.
*
   * @param {string} name String with the turbine name - Works with "Delta-1"
                  * @returns "D1"
                  */
const ShortName = (name,zoom) => {
    if(name.slice(0,3)==="WTG") name = name.slice(3)
    return name;

  // if(name.includes("-")){
  //   if(name.includes("NEAV")) return name;
  //   let numberArray = name.split("-", 2)
  //   let stringSlice = name.slice(0, 1 - name.length)
  //   stringSlice = stringSlice + numberArray[1]
  //   return stringSlice
  // }
  // else{
  //   if(zoom === 12){
  //     if(name.slice(0,3)==="WTG")
  //     name = "G-"+name.slice(3)
  //   } 
  //   return name;
  // }
}

const TextOverlay = (TurbineData, zoom, textSize, map) =>{
   // Square of textoverlay
   let y;
   let x = 0
    
// Centering the Turbine name   
   TurbineData.name = ShortName(TurbineData.name, zoom);

   const tbLat = Number(TurbineData.lat);
   const tbLong = Number(TurbineData.long-0.007);
   let  bounds = [
    //Calculate the latitude displacement of the textoverlay - This changes because world maps are stretched.
    [boundsDisplacement(tbLat) , tbLong ],
    [boundsDisplacement(tbLat) - 0.0085488, tbLong + 0.02],
    ];

    
   if(zoom ===12){
     //Zoom displacement is the same thing as the world map.
     y=(zoomDisplacement(tbLat))*.95;
     x = -3.5*TurbineData.name.length+34.78571;
   }
   else if(zoom ===13){
    y=zoomDisplacement(tbLat)*0.45;
    x =-2.48214*TurbineData.name.length+35.57143
  }
   else textSize = "0";

 // Square of textoverlay


      return(
        <SVGOverlay attributes={{ stroke: "red" }} bounds={bounds}>
                      <text x={x+"%"} y={y+"%"} stroke="black"
                       style={{ fontSize: textSize + "px", fontWeight: "lighter", fontFamily: "Segoe UI"}}>
                        {TurbineData.name}
                      </text>
                    </SVGOverlay>
      )
 }


 /**
* Calcuclates the latitude displacement of the icons.
* @returns x latitude
*/
export function boundsDisplacement(y) {
 let a = 1.00002343205476;
 let b;
 let displacedLatitude;
 
 if(y<0) b = -0.0002993837354598
 else b = -0.0017993837354598
 
 //Inverse 	y = A+ B/x		
  displacedLatitude = a+(b/y);
  return y*displacedLatitude;
};

/**
* Calcuclates the latitude displacement of the icons on zoom
* @returns x latitude
*/
export function zoomDisplacement(y) {
  let a;
  let b;
  let c;
  let displacedLatitude;
 //Quadratic regression A+Bx+Cx2			
      a = 59.923344677181659129934638317735445390555379948549
      b = 0.0501081919082070857230170868576741363683229640826
      c = -0.007736090300905467051669166572883871001791987804942
      displacedLatitude = a+b*y+c*y**2;
      return displacedLatitude;
 };


/**
* Calcuclates the posisiton at the map in the middle of the given windturbine park.
* @returns array [Latitude,Longitude]
*/
export const startViewPosition = (mapConfig) => {

  let Latitude = 0;
  let Longitude = 0;
  const length = mapConfig.length;
  mapConfig.forEach((element) => {
    Latitude += Number(element.lat);
    Longitude += Number(element.long);
  });
  const avgPosition = [Latitude / length, Longitude / length];
  return avgPosition;

};




export const DisplayAlarm = () => {
  return;
}
